import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import { connect } from 'react-redux';

const NumberOfRetailersContainer = ({
  childComponent: ChildComponent,
  ...props
}) => <ChildComponent {...props} />;

const mapStateToProps = ({ content = {}, productSwatch = {} }) => {
  const selectedSKU = R.prop('selectedSKU')(productSwatch);

  const retailersInfo = R.path(['retailersInfo'])(content);
  const retailerInfo = R.prop(selectedSKU)(retailersInfo);

  return {
    numberOfRetailers: R.prop('numberOfRetailers')(retailerInfo),
    inStock: R.prop('inStock')(retailerInfo),
    price: R.path(['lowestPrice', 'price'])(retailerInfo),
    fromRetailersLabel: R.path(['productDetails', 'fromRetailersLabel'])(
      content
    ),
    priceRetailersSingularLabel: R.path([
      'productDetails',
      'priceRetailersSingularLabel',
    ])(content),
    priceRetailersPluralLabel: R.path([
      'productDetails',
      'priceRetailersPluralLabel',
    ])(content),
  };
};

NumberOfRetailersContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(NumberOfRetailersContainer);
